import en from './modules/en'
import zh from './modules/zh'
import { getCookie, getURLParamH5 } from './cookie'
const langDic = {
  zh: zh,
  en: en
}

let langKey = getCookie('EMAP_LANG') || getURLParamH5('EMAP_LANG') || 'zh'
let lang = langDic[langKey]

export const getLocalI18nH5 = (path, obj) => {
  if (!path) return ''
  const array = path.split('.')
  let current = lang
  let value = ''
  for (let i = 0, j = array.length; i < j; i++) {
    const property = array[i]
    value = current[property]
    if (i === j - 1) {
      if (obj) {
        return valueHandle(value, obj)
      }
      return value
    }

    if (!value) return ''
    current = value
  }
  return ''
}

const valueHandle = (val, Obj)=>{
  Object.keys(Obj).forEach(key=>{
    var exp = new RegExp(`{${key}}`, 'g')
    val = val.replace(exp, Obj[key])
  })
  return val
}
